
export default function Footer() {
  const sections = [
    { name: 'Inicio', href: '#inicio' },
    { name: 'Sobre nosotros', href: '#sobre-nosotros' },
    { name: 'APP oficial', href: '#app-oficial' },
    { name: 'Galería', href: '#galeria' },
    { name: 'Registro y sorteo', href: '#registro' },
    { name: 'FAQ', href: '#faq' }
  ];

  const support = [
    { name: 'Política de privacidad', href: 'https://www.acsamarita.com/politica-privacidad' },
    { name: 'Bases legales del sorteo', href: 'https://www.campamentoreal.es/assets/pdf/bases-legales-sorteo-v2024.pdf' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Secciones</h3>
            <ul className="space-y-2">
              {sections.map((item) => (
                <li key={item.name}>
                  <a href={item.href} className="text-gray-300 hover:text-white transition-colors duration-200">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Soporte</h3>
            <ul className="space-y-2">
              {support.map((item) => (
                <li key={item.name}>
                  <a 
                    href={item.href} 
                    className="text-gray-300 hover:text-white transition-colors duration-200"
                    target={item.href.startsWith('http') ? '_blank' : '_self'}
                    rel={item.href.startsWith('http') ? 'noopener noreferrer' : ''}
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-4">
              <p className="text-gray-300 text-sm">
                + Info en <a href="mailto:info@campamentoreal.app" className="text-red-400 hover:text-red-300">info@campamentoreal.app</a>
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Nuestra App</h3>
            <div className="space-y-3">
              <a 
                href="https://apps.apple.com/app/campamento-real/id6467151946"
                className="flex items-center space-x-3 text-gray-300 hover:text-white transition-colors duration-200"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-apple-line text-xl"></i>
                </div>
                <div>
                  <div className="text-sm">Descargar en</div>
                  <div className="font-semibold">AppStore</div>
                </div>
              </a>
              <a 
                href="https://play.google.com/store/apps/details?id=es.campamentoreal.clientapp"
                className="flex items-center space-x-3 text-gray-300 hover:text-white transition-colors duration-200"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-google-play-line text-xl"></i>
                </div>
                <div>
                  <div className="text-sm">Descargar en</div>
                  <div className="font-semibold">Play Store</div>
                </div>
              </a>
            </div>
          </div>

          <div>
            <div className="space-y-4">
              <img 
                src="https://static.readdy.ai/image/40f88d0dea4cb4de19f5f0c481deadea/ee8a8629a53d00405a0b91d6c164aa78.jpeg" 
                alt="Ayuntamiento de Alcoy" 
                className="w-48 h-auto mb-4 rounded-lg"
              />
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-300 text-sm">
            Diseño y desarrollo por{' '}
            <a 
              href="https://www.acsamarita.com/" 
              className="text-red-400 hover:text-red-300"
              target="_blank"
              rel="noopener noreferrer"
            >
              Asociación SAMARITA
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
